/**
 * Badge colorato per lo stato di un ordine di acquisto.
 * Usa solo classi Tailwind dal design system.
 */

import React from 'react';

interface StatoOrdineBadgeProps {
  stato: string;
}

const STATI: Record<string, { label: string; className: string }> = {
  bozza: { label: 'Bozza', className: 'bg-muted text-muted-foreground' },
  confermato: { label: 'Confermato', className: 'bg-primary/10 text-primary' },
  inviato: { label: 'Inviato', className: 'bg-accent/10 text-accent' },
  confermato_fornitore: { label: 'Confermato forn.', className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300' },
  in_spedizione: { label: 'In spedizione', className: 'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-300' },
  consegnato: { label: 'Consegnato', className: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300' },
  in_ricezione: { label: 'In ricezione', className: 'bg-warning/10 text-warning' },
  chiuso: { label: 'Chiuso', className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' },
  annullato: { label: 'Annullato', className: 'bg-destructive/10 text-destructive' },
};

export function StatoOrdineBadge({ stato }: StatoOrdineBadgeProps) {
  const config = STATI[stato] ?? { label: stato, className: 'bg-muted text-muted-foreground' };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
}
